import { useEffect } from 'react';
import { useUniSelector } from '../store/types';
import { useNavigate } from 'react-router';
import { useTabId } from '../components/keep-alive/TabContext';
import {
  getDefaultTabs,
  getTabs,
  lastActiveTabIdSelector,
} from '../features/navigation/selectors';

/*
 * Restores the last selected tab that was opened before user was logged-out.
 * #46420: Store previous opened tabs on logout and on autologout
 */
export const RestoreSelectedTab = () => {
  const navigate = useNavigate();
  const lastSelectedTabId = useUniSelector(lastActiveTabIdSelector);

  const tabs = useUniSelector(getTabs);
  const defaultTabs = useUniSelector(getDefaultTabs);
  const currentTabId = useTabId();
  useEffect(
    () => {
      if (currentTabId === lastSelectedTabId) return;

      const tab =
        tabs.find((x) => x.id === lastSelectedTabId) ||
        defaultTabs.find((x) => x.id === lastSelectedTabId);
      if (tab) {
        navigate({ pathname: tab.path, search: tab.search }, { replace: true });
      }
    }, // do this once (i.e. do NOT add dependency on lastSelectedTabId)
    [],
  );
  return null;
};
